import { QualityData, QualityDataProps } from '../../Cards/QualityData'
import { useTranslation } from 'react-i18next'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { useState } from 'react'
import { useHRExpertMentors } from '../../../../../../hooks/useHRExpertMentors'
import { ModalExpertMentorStatus } from '../ModalExpertMentorStatus'
import { useCourses } from '../../../../../../hooks/ApiHooks/useCourses'
import { useTeam } from '../../../../Hooks/useTeam'

export const ExpertMentorProgressCard = () => {
    const { t } = useTranslation('teamMonitor')
    const { mentors } = useHRExpertMentors()
    const { courseID } = useTeam()
    const { getCourseData } = useCourses()
    const course = getCourseData(courseID ?? '')

    const hideCard = course?.courseFlags?.helpRequestType !== 'mentor'

    const [showModal, setShowModal] = useState(false)

    const props: QualityDataProps = {
        title: t('Expert Mentors'),
        status: [
            {
                icon: ['fas', 'circle-check'] as IconProp,
                label: t('Available'),
                value: mentors?.availables.length ?? 0,
            },
            {
                icon: ['fas', 'clock'] as IconProp,
                label: t('Busy'),
                value: mentors?.busy.length ?? 0,
            },
            {
                icon: ['fas', 'ban'] as IconProp,
                label: t('Disconnected'),
                value: mentors?.unavailable.length ?? 0,
            },
        ],
        footer: (
            <button className="link" onClick={() => setShowModal(true)}>
                {t('Show details')}
            </button>
        ),
        info: t(
            'Displays in real time how many expert mentors are available to help, how many are currently busy assisting requests, and how many are disconnected. This information allows you to monitor the team’s support capacity and responsiveness during the session.'
        ),
    }

    if (hideCard) return null

    return (
        <>
            <QualityData {...props} />
            <ModalExpertMentorStatus isOpen={showModal} onClose={() => setShowModal(false)} />
        </>
    )
}
